export class Pages {
  static landing: string = "/landing";
}
